import { put, takeEvery, call } from "redux-saga/effects";
import { useSelector, useDispatch } from "react-redux";
import * as types from "../types";
import {
  uploadFileToBlob,
  sendOtpToUser,
  verifyOtpWithUser,
  getBlobStorageDetails,
  getFilesData,
  postFileDetasils,
  updateScheduleCallTime,
  updateStopCall,
  triggerFileProcessingAPI,
  downloadFileFromBlob,
  stopCurrentCall,
  getGlobalConfigParamsData,
  updateGlobalConfigParamsData,
  disableFile
} from "redux/agent";

function* putCSVFileInBlobSaga(action) {
  try {
    yield put({
      type: types.SET_LOADER,
      payload: true,
    });
    let fetchBlobStorageResponse = yield getBlobStorageDetails();
    if (fetchBlobStorageResponse) {
      let blobDetails = fetchBlobStorageResponse.data;
      action.payload.blobDetails = blobDetails;
    } else {
      throw new Error("Error happened whle fetch blob details from API");
    }
    let response = yield call(uploadFileToBlob, action.payload);
    const apiResponse = response;
    if (apiResponse) {
      let blobResponsePayload = {
        isBlobUploaded: true,
        csvFileName: action.payload.fileDetails.fileName,
        uploadedFileName: action.payload.fileDetails.fileUpdatedName,
      };

      let filePayload = {
        data: {
          fileName: action.payload.fileDetails.fileName,
          uploadedFileName: action.payload.fileDetails.fileUpdatedName,
          uploderName: action.payload.fileDetails.uploaderName,
          uploderEmail: action.payload.fileDetails.uploaderEmail,
          workflowId: action.payload.fileDetails.workflowId,
          workflowName: action.payload.fileDetails.workflowName,
        },
        token: action.payload.token,
      };
      let postFileDetailsToDB = yield postFileDetasils(filePayload);

      console.log("response of post request to DB", postFileDetailsToDB);

      if (postFileDetailsToDB) {
        let payloadTrigger = {
          data: {
            uploadedFileName: action.payload.fileDetails.fileUpdatedName,
            fileName: action.payload.fileDetails.fileName,
            scheduledCallTime: "",
            fileId: postFileDetailsToDB.data.message._id,
            workflowId: action.payload.fileDetails.workflowId,
          },
          token: action.payload.token,
        };
        let triggerProcess = yield triggerFileProcessingAPI(payloadTrigger);
        console.log("Trigger response", triggerProcess);
        if (triggerProcess.status === 200) {
          console.log("Workflow triggered=======");
        }
      }

      yield put({
        type: types.PUT_CSV_FILE_IN_BLOB_SUCCESS,
        payload: blobResponsePayload,
      });
      yield put({
        type: types.OPEN_UPDATE_MODAL,
        payload: "File uploaded. Please close the popup to check the status",
      });
    } else {
      yield put({
        type: types.PUT_CSV_FILE_IN_BLOB_FAILED,
      });
      yield put({
        type: types.OPEN_UPDATE_MODAL,
        payload: "Failed to upload the file",
      });
    }
  } catch (error) {
    if (
      error.response.status === 400 &&
      error.response.data.message === "Invalid token"
    ) {
      console.log("Error in file fetch====> User should be log out");
      yield put({
        type: types.USER_LOGOUT,
      });
    }
    yield put({
      type: types.PUT_CSV_FILE_IN_BLOB_FAILED,
    });
    yield put({
      type: types.OPEN_UPDATE_MODAL,
      payload: "Failed to upload the file",
    });
  } finally {
    yield put({
      type: types.SET_LOADER,
      payload: false,
    });
  }
}

function* postOtpToUserSaga(action) {
  try {
    yield put({
      type: types.SET_LOADER,
      payload: true,
    });
    let response = yield sendOtpToUser(action.payload);
    if (response.status === 200) {
      yield put({
        type: types.POST_OTP_TO_USER_SUCCESS,
      });
    } else {
      yield put({
        type: types.POST_OTP_TO_USER_FAILED,
      });
    }
  } catch (error) {
    if (
      error.response.status === 400 &&
      error.response.data.message === "Invalid token"
    ) {
      console.log("Error in file fetch====> User should be log out");
      yield put({
        type: types.USER_LOGOUT,
      });
    }
    yield put({
      type: types.OPEN_UPDATE_MODAL,
      payload: "Error happened while sending OTP please retry",
    });
  } finally {
    yield put({
      type: types.SET_LOADER,
      payload: false,
    });
  }
}

function* verifyOtpWithUserSaga(action) {
  try {
    yield put({
      type: types.SET_LOADER,
      payload: true,
    });
    let response = yield verifyOtpWithUser(action.payload);
    if (response.status === 200) {
      let detailsOfOtpApproval = response.data.payload;
      if (detailsOfOtpApproval.status === "approved") {
        yield put({
          type: types.VERIFY_OTP_WITH_USER_SUCCESS,
        });
        yield put({
          type: types.OPEN_UPDATE_MODAL,
          payload: "Verification successful. Call will be scheduled",
        });
      } else {
        yield put({
          type: types.VERIFY_OTP_WITH_USER_FAILED,
        });
        yield put({
          type: types.OPEN_UPDATE_MODAL,
          payload: "Incorrect OTP. Verification failed.",
        });
      }
    } else {
      yield put({
        type: types.VERIFY_OTP_WITH_USER_FAILED,
      });
      yield put({
        type: types.OPEN_UPDATE_MODAL,
        payload: "OTP verification failed.",
      });
    }
  } catch (error) {
    if (
      error.response.status === 400 &&
      error.response.data.message === "Invalid token"
    ) {
      console.log("Error in file fetch====> User should be log out");
      yield put({
        type: types.USER_LOGOUT,
      });
    }
    yield put({
      type: types.OPEN_UPDATE_MODAL,
      payload: "Error happened while verifying OTP please retry",
    });
  } finally {
    yield put({
      type: types.SET_LOADER,
      payload: false,
    });
  }
}

function* closeOTPModal() {
  yield put({
    type: types.CLOSE_OTP_MODAL_SUCCESS,
  });
}

function* getFilesDataSaga(action) {
  try {
    yield put({
      type: types.SET_LOADER,
      payload: true,
    });
    let response = yield getFilesData(action.payload);
    console.log("Initial files response=---->", response);
    if (response.status === 200) {
      const fileList = response.data;
      yield put({
        type: types.GET_FILES_DATA_SUCCESS,
        payload: { fileData: fileList },
      });
    } else {
      yield put({
        type: types.GET_FILES_DATA_FAILED,
      });
    }
  } catch (error) {
    if (
      (error.response.status === 400 &&
      error.response.data.message === "Invalid token") || (error.response.status === 403 &&
        error.response.data.message === "Invalid token")
    ) {
      yield put({
        type: types.USER_LOGOUT,
      });
    } else {
      yield put({
        type: types.OPEN_UPDATE_MODAL,
        payload: "Error happened while fetch file list API",
      });
    }
  } finally {
    yield put({
      type: types.SET_LOADER,
      payload: false,
    });
  }
}

function* updateScheduleCallTimeSaga(action) {
  try {
    yield put({
      type: types.SET_LOADER,
      payload: true,
    });

    console.log("Payload=====>", action);
    let response = yield updateScheduleCallTime(action.payload);
    console.log("Initial files response=---->", response);
    if (response.status === 200) {
      yield put({
        type: types.UPDATE_SCHEDULE_CALL_TIME_SUCCESS,
      });
    } else {
      yield put({
        type: types.UPDATE_SCHEDULE_CALL_TIME_FAILED,
      });
    }
  } catch (error) {
    if (
      error.response.status === 400 &&
      error.response.data.message === "Invalid token"
    ) {
      yield put({
        type: types.USER_LOGOUT,
      });
    }
    yield put({
      type: types.OPEN_UPDATE_MODAL,
      payload: "Error happened while updating file schedule time",
    });
  } finally {
    yield put({
      type: types.SET_LOADER,
      payload: false,
    });
  }
}

function* updateStopCallSaga(action) {
  try {
    yield put({
      type: types.SET_LOADER,
      payload: true,
    });

    
    console.log("Payload===== Stop call>", action);
    const responseStopCallAPI = yield stopCurrentCall(action.payload)
    console.log("Response from server stop call",responseStopCallAPI);

    let response = yield updateStopCall(action.payload);
    console.log("Initial stop ccall response---->", response);
    if (responseStopCallAPI.status === 200) {
      yield put({
        type: types.UPDATE_STOP_CALL_SUCCESS,
        payload:responseStopCallAPI.data
      });
    } else {
      yield put({
        type: types.UPDATE_STOP_CALL_FAILED,
      });
    }
  } catch (error) {
    if (
      error.response.status === 400 &&
      error.response.data.message === "Invalid token"
    ) {
      yield put({
        type: types.USER_LOGOUT,
      });
    }
    yield put({
      type: types.OPEN_UPDATE_MODAL,
      payload: "Error Stopping Call",
    });
  } finally {
    yield put({
      type: types.SET_LOADER,
      payload: false,
    });
  }
}

function* downloadBlobFileSaga(action) {
  try {
    yield put({
      type: types.SET_LOADER,
      payload: true,
    });
    let fetchBlobStorageResponse = yield getBlobStorageDetails();
    if (fetchBlobStorageResponse) {
      let blobDetails = fetchBlobStorageResponse.data;
      action.payload.blobDetails = blobDetails;
    } else {
      throw new Error("Error happened whle fetch blob details from API");
    }
    let response = yield call(downloadFileFromBlob, action.payload);
    console.log("Response for Download", response);
    window.open(response.url);
  } catch (error) {
    if (
      error.response.status === 400 &&
      error.response.data.message === "Invalid token"
    ) {
      console.log("Error in file fetch====> User should be log out");
      yield put({
        type: types.USER_LOGOUT,
      });
    }
  } finally {
    yield put({
      type: types.SET_LOADER,
      payload: false,
    });
  }
}

function* stopCurrentCallSaga(action) {
  try {
    yield put({
      type: types.SET_LOADER,
      payload: true,
    });
    //******Its commented for now uncomment when required
    // let requestToStopCall = yield stopCurrentCall()
    console.log("Stop call executed");
    yield put({
      type: types.OPEN_UPDATE_MODAL,
      payload: "Stop call executed",
    });
  } catch (error) {
    yield put({
      type: types.OPEN_UPDATE_MODAL,
      payload: "Error happened while requesting to stop call",
    });
  } finally {
    yield put({
      type: types.SET_LOADER,
      payload: false,
    });
  }
}

function* fetchGlobalConfigSaga(action) {
  console.log(" saga call ed for glbal config")
  try {
    yield put({
      type: types.SET_LOADER,
      payload: true,
    });

    console.log("Payload----> Global congif req",action)
    let fetchData = yield getGlobalConfigParamsData(action.payload);
    console.log("Fetch data global config--->",fetchData)
    if (fetchData) {
      yield put({
        type: types.FETCH_GLOBAL_CONFIG_SUCCESS,
        payload: { globalConfigParams: fetchData.data },
      });
    }
  } catch (error) {
    yield put({
      type: types.OPEN_UPDATE_MODAL,
      payload: "Error happened while fetching global config",
    });
  } finally {
    yield put({
      type: types.SET_LOADER,
      payload: false,
    });
  }
}

function* updateGlobalConfigSaga(action) {
  console.log(" saga call ed for update glbal config")
  try {
    yield put({
      type: types.SET_LOADER,
      payload: true,
    });

    let updateData = yield updateGlobalConfigParamsData(action.payload);
    console.log("Fetch data",updateData)
    if (updateData) {
      yield put({
        type: types.UPDATE_GLOBAL_CONFIG_SUCCESS,
      });
      yield put({
        type: types.OPEN_UPDATE_MODAL,
        payload: "Global config updated successfully.",
      });
    }
  } catch (error) {
    yield put({
      type: types.OPEN_UPDATE_MODAL,
      payload: "Error happened while updating global config",
    });
  } finally {
    yield put({
      type: types.SET_LOADER,
      payload: false,
    });
  }
}

function* setModalForStopCall(action) {
  console.log(" Close Modal ")
  try {
    yield put({
      type: types.SET_MODAL_STOP_CALL_SUCCESS,
      payload: false,
    });
  } catch (error) {
    yield put({
      type: types.OPEN_UPDATE_MODAL,
      payload: "Error happened while updating global config",
    });
  } finally {
    yield put({
      type: types.SET_LOADER,
      payload: false,
    });
  }
}

function* disableFileSaga(action) {
  try {
    yield put({
      type: types.SET_LOADER,
      payload: true,
    });

    
    let response = yield disableFile(action.payload);
    console.log("Initial stop ccall response---->", response);
    if (response.status === 200) {
      yield put({
        type: types.DISABLE_FILE_SUCCESS,
        payload:true
      });
    } else {
      yield put({
        type: types.DISABLE_FILE_FAILED,
      });
    }
  } catch (error) {
    if (
      error.response.status === 400 &&
      error.response.data.message === "Invalid token"
    ) {
      yield put({
        type: types.USER_LOGOUT,
      });
    }
    yield put({
      type: types.OPEN_UPDATE_MODAL,
      payload: "Error Stopping Call",
    });
  } finally {
    yield put({
      type: types.SET_LOADER,
      payload: false,
    });
  }
}

function* initateCallSaga() {
  yield takeEvery(types.PUT_CSV_FILE_IN_BLOB, putCSVFileInBlobSaga);
  yield takeEvery(types.POST_OTP_TO_USER, postOtpToUserSaga);
  yield takeEvery(types.VERIFY_OTP_WITH_USER, verifyOtpWithUserSaga);
  yield takeEvery(types.CLOSE_OTP_MODAL, closeOTPModal);
  yield takeEvery(types.GET_FILES_DATA, getFilesDataSaga);
  yield takeEvery(types.UPDATE_SCHEDULE_CALL_TIME, updateScheduleCallTimeSaga);
  yield takeEvery(types.UPDATE_STOP_CALL, updateStopCallSaga);
  yield takeEvery(types.DOWNLOAD_BLOB_FILE, downloadBlobFileSaga);
  yield takeEvery(types.STOP_CURRENT_CALL, stopCurrentCallSaga);
  yield takeEvery(types.FETCH_GLOBAL_CONFIG, fetchGlobalConfigSaga);
  yield takeEvery(types.UPDATE_GLOBAL_CONFIG,updateGlobalConfigSaga)
  yield takeEvery(types.SET_MODAL_STOP_CALL,setModalForStopCall)
  yield takeEvery(types.DISABLE_FILE,disableFileSaga)
}

export default initateCallSaga;
